import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=9f4c3636&scoped=true"
import script from "./Tabs.vue?vue&type=script&setup=true&lang=js"
export * from "./Tabs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=9f4c3636&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4c3636",
  null
  
)

export default component.exports